export default __webpack_public_path__ + "static/media/VerifyAccount.07aeea1a.svg";